module.exports = __webpack_public_path__ + "static/media/retreat-01.1683a3c7.jpg";